module.exports = __webpack_public_path__ + "static/media/cylinder.f45aac98.svg";